import f1 from "./Facilities (1).jpg";
import f2 from "./Facilities (2).jpg";
import f3 from "./Facilities (3).jpg";
import f4 from "./Facilities (4).jpg";
import f5 from "./Facilities (5).jpg";
import f6 from "./Facilities (6).jpg";

const aboutImages = [f1, f2, f3, f4, f5, f6];

export default aboutImages;
